import { Tooltip as ReactTooltip } from "react-tooltip";

const ItemValue = ({ item }) => {
  const value = item?.value || item?.Value;
  if (!value || typeof value === "object") return "-";

  // Convert to string and check word count
  const stringValue = String(value);
  const isUrl = stringValue.startsWith("http");
  const shouldSlice = !isUrl && stringValue.length > 300;
  const displayedValue = shouldSlice
    ? stringValue.slice(0, 50) + "..."
    : stringValue;

  return (
    <span
      data-tooltip-id={
        shouldSlice ? "fullValueTooltip-" + item?.key : undefined
      }
      data-tooltip-content={shouldSlice ? stringValue : undefined}
      className="cursor-pointer break-words"
    >
      {isUrl ? <a href={displayedValue}>{displayedValue}</a> : displayedValue}

      {shouldSlice && (
        <ReactTooltip
          id={"fullValueTooltip-" + item?.key}
          place="top"
          className="max-w-[350px] whitespace-normal break-words text-left p-2 bg-gray-800 text-white rounded-lg shadow-lg z-50"
        />
      )}
    </span>
  );
};

export default ItemValue;
